import { SceneRenderer } from './SceneRenderer';
import { DepthMapRenderer } from './DepthMapRenderer';
import { DeferredSceneRenderer } from './DeferredSceneRenderer';
import { DepthMode } from './index';
import { Context } from '../context/Context';
import { Camera } from '../camera';
import { Scene } from '../scene/Scene';

export class CompositeSceneRenderer extends SceneRenderer {
  public depthRender: boolean;

  public depthRenderer: DepthMapRenderer;
  public deferredRenderer: DeferredSceneRenderer;

  constructor() {
    super();
    this.depthRender = false;

    this.deferredRenderer = new DeferredSceneRenderer();
    this.depthRenderer = new DepthMapRenderer(DepthMode.CameraDistance);
  }

  public init(ctx: Context): void {
    this.deferredRenderer.init(ctx);
    this.depthRenderer.init(ctx);
  }

  public override resize(): void {
    this.deferredRenderer.resize();
  }

  public destroy(): void {
    this.deferredRenderer.destroy();
    this.depthRenderer.destroy();
  }

  public render(scene: Scene, camera: Camera, buffer: WebGLFramebuffer): void {
    const renderer = this.depthRender ? this.depthRenderer : this.deferredRenderer;
    renderer.render(scene, camera, buffer);
  }
}
